import { Directive, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';

import { DynamicComponent, GUIComponent, HisBaseGlobalsService } from 'hisng';

import { DynamicContentUtils } from '../service/dynamic-content/dynamic-content-utils';
import { ResTabMenuItem } from '../model/core/tab-menu-item';

@Directive( {
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: 'p-tabView'
} )
export class TabViewDirective implements OnChanges {
    @Input( 'tabMenuItems' ) tabMenuItems: ResTabMenuItem[];
    @Input( 'managedContexts' ) managedContexts: string[];
    @Input() dynamicComponent: DynamicComponent;
    @Output() tabMenuItemsChange: EventEmitter<ResTabMenuItem[]> = new EventEmitter<ResTabMenuItem[]>();

    constructor( private hisBaseGlobalsService: HisBaseGlobalsService,
        private dynamicContentUtils: DynamicContentUtils ) {
    }

    ngOnChanges( changes: SimpleChanges ): void {
        if ( this.tabMenuItems && changes.managedContexts ) {
            this.manageTabMenuItems();
            this.tabMenuItemsChange.emit( this.tabMenuItems );
        }
    }

    public manageTabMenuItems(): void {
        this.tabMenuItems.forEach( ( tabMenuItem: ResTabMenuItem ) => {
            // static content / tabs
            if ( !tabMenuItem.isDynamic ) {
                if ( tabMenuItem.hisDdKey ) {
                    if ( this.hisBaseGlobalsService.getDd( tabMenuItem.hisDdKey, this.managedContexts ).hidden ) {
                        tabMenuItem.isHidden = true;
                    } else {
                        tabMenuItem.isHidden = false;
                    }
                } else if ( tabMenuItem.fieldsetDdKeys ) {
                    if ( this.dynamicContentUtils.isStaticContentVisible( tabMenuItem.fieldsetDdKeys, this.dynamicComponent, this.managedContexts )
                        || this.dynamicContentUtils.isDynamicContentVisible( tabMenuItem.i18nKey, this.dynamicComponent, this.managedContexts ) ) {
                        tabMenuItem.isHidden = false;
                    } else {
                        tabMenuItem.isHidden = true;
                    }      
                }
            }
            // dynamic content / tabs
            if ( tabMenuItem.isDynamic && this.dynamicComponent ) {
                let tabMenuChild = this.dynamicComponent.guiComponent.children.find(
                    ( tabChild: GUIComponent ) => tabChild.name === tabMenuItem.i18nKey );
                if ( tabMenuChild ) {
                    if ( !this.dynamicContentUtils.atLeatOneTabChildFieldNotHidden( tabMenuChild.children, this.managedContexts ) ) {
                        tabMenuItem.isHidden = true;
                    } else {
                        tabMenuItem.isHidden = false;
                    }      
                }
            }
        } );
    }

}
